import { Breakpoints, styled } from "@vw-marketing/us-components";

export const StyledLineDivisorContainer = styled.div`
    height: 1px;
    background: #DFE4E8;
    border: 1px solid #F0F0F0;
    transform: matrix(1, 0, 0, -1, 0, 0);
    margin: 30px 0px 20px 0px;
    &.mobile-view {
        @media screen and (min-width: ${Breakpoints.b960}px) {
            display: none;
        }
    }

`
